module.exports = __webpack_public_path__ + "static/img/海报@3x.9792564.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/首页/海报@3x.png
// module id = 9gxp
// module chunks = 192